/** Whether a menu (a kebab, a card's context menu) is open anywhere on the page. */
export const hasOpenMenu = () =>
    document.querySelector("[role='menu'][data-open]") !== null;
